import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

import { Header } from './header';
import { Footer } from './footer';

export const Layout: FunctionComponent = (props) => {
  return (
    <Box
      my={{
        xs: 1,
        sm: 2,
      }}
      mx="auto"
      px={{
        xs: 2,
        sm: 3,
      }}
      style={{
        maxWidth: 960,
      }}
    >
      <Header />
      <Box
        marginTop={{
          xs: 1,
          sm: 2,
          md: 5,
          lg: 8,
        }}
      >
        {props.children}
      </Box>
      <Footer />
      {/* <MessengerChat /> */}
      {/* <Background /> */}
    </Box>
  );
};

export default Layout;
